import { useFeatureValue } from '@growthbook/growthbook-react';

/**
 * Hook to get BGCC (Background & Credit Check) entitlement status for the current company
 * Fetches directly from GrowthBook SDK in the frontend
 */
export const useBgccEntitlement = () => {
  // Get the feature value from GrowthBook
  // Default to true for backward compatibility (all existing companies have BGCC)
  const bgccEnabled = useFeatureValue('bgcc-enabled', true);
  
  return {
    data: {
      bgccEnabled,
    },
    isLoading: false, // GrowthBook loads synchronously
  };
};

